import gql from "graphql-tag";

export const FIND_ALL_FAQ_CATEGORIES = gql`
  query FindAllFaqCategories {
    findAllFaqCategories {
      _id
      name
    }
  }
`;

export const FIND_FAQ_BY_CATEGORY = gql`
  query FindFaqByCategory($category: MOID!) {
    findFaqByCategory(category: $category) {
      _id
      question
      answer
      category {
        _id
        name
      }
      isPublished
    }
  }
`;
